import './polifill'
import Vue from 'vue'
import './config'
import './const'
import './directive'
import './filter'
import './validator'

import Plugins from './plugins'
import router from './router'
import store from './store'
import './appCallFunction'

import App from './components/App'

Vue.config.productionTip = false

const init = async () => {
  // 최초 셋팅
  try {
    await store.dispatch('auth/init')
  } finally {
    global.$vm = new Vue({
      router,
      store,
      vuetify: Plugins.vuetify,
      render: (h) => h(App),
    }).$mount('#app')
    global.$vm.$gtm.trackEvent({ event: 'init-app' })
  }
}
init()
